import type { CreateSessionInput } from "@orni/domain-typescript";

export interface NormalizedSessionCreateInput {
  workspaceRoot: string;
  workspaceMode: "existing" | "session-id" | "custom";
  workspaceSubdirectory?: string;
  model: string;
  permissionMode: NonNullable<CreateSessionInput["permissionMode"]>;
}

/** Keep Local and Cloud creation semantics identical before transport mapping. */
export function normalizeSessionCreateInput(
  input: CreateSessionInput,
  sessionRoot: string,
): NormalizedSessionCreateInput {
  return {
    workspaceRoot: normalizeSessionRoot(input.workspaceRoot || sessionRoot),
    workspaceMode: input.importExisting
      ? "existing"
      : input.workspaceMode ?? (input.customFolder ? "custom" : "session-id"),
    workspaceSubdirectory: input.customFolder,
    model: input.model || "interactive_terminal",
    permissionMode: input.permissionMode ?? "workspace-write",
  };
}

export function normalizeSessionRoot(value: string): string {
  return value.trim().replace(/\/$/, "");
}
